export default __webpack_public_path__ + "static/media/6.9fa076c2.webp";